import moment from "moment";
import { timezoneDateFormat } from "./timezoneDateFormat";

 const formatDateForTimezone = (dateString:any) => {
         if (!dateString) return '';
  
        const momentDate = moment(dateString, "MMM, DD YYYY");
  
        if (!momentDate.isValid()) {
            return dateString; 
        }
            
        const format = timezoneDateFormat();
            
        if (format === "dd/MM/yyyy") {
            return momentDate.format("DD/MM/YYYY"); // New Zealand format
        } else {
            return momentDate.format("MM/DD/YYYY"); // US format
        }
        };

export default formatDateForTimezone